var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.12584 0.573484L0.825357 6.51436C0.455062 7.18089 0.93703 8 1.69951 8H8.30049C9.06297 8 9.54494 7.18089 9.17464 6.51436L5.87416 0.573483C5.49315 -0.112327 4.50685 -0.112325 4.12584 0.573484Z",
    fill: "#50CC72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrown);
export default __webpack_public_path__ + "static/media/grown.6463985cf6ea047b6d8c54bf2d75f146.svg";
export { ForwardRef as ReactComponent };